import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { theme } from "../../../constants";
import { CrossIcon } from "../../../constants/icons";
import { AppState, useSelector } from "../../../store/store";

interface ButtonProps {
  symbol: string;
  label: string;
  handleRemove: (e: React.MouseEvent<HTMLDivElement>) => void;
  onClick: () => void;
  logo: string;
  isActive: boolean;
}

const AssetButton: React.FC<ButtonProps> = ({
  logo,
  symbol,
  label,
  handleRemove,
  onClick,
  isActive,
}) => {
  const { t } = useTranslation();
  const { selectedSymbols } = useSelector<AppState["home"]>(({ home }) => home);

  return (
    <div
      onClick={onClick}
      className={`home-trade__assets-button`}
      style={{
        width: isActive ? "100%" : "40px",
        minWidth: "40px",
        height: "40px",
        border: isActive ? "none" : "1px solid grey",
        background: isActive ? theme.colors.lightGrey : "none",
      }}
    >
      <div style={{ display: "flex" }}>
        <img src={logo} alt="symbol logo" />{" "}
        {isActive && (
          <div>
            <Typography sx={{ pl: 1, color: "white" }} variant="body2">
              {label}
            </Typography>
            <p
              style={{
                lineHeight: 0,
                color: "grey",
                paddingLeft: "8px",
                paddingTop: "8px",
                fontSize: 11,
              }}
            >
              {t("binary")}
            </p>
          </div>
        )}
      </div>
      {isActive && selectedSymbols.length > 1 && (
        <CrossIcon
          onClick={(e: any) => handleRemove(e)}
          color="white"
          style={{ marginTop: "auto", marginBottom: "auto" }}
        />
      )}
    </div>
  );
};

export default AssetButton;
